import { NewArrivalMagazineSearchType } from '@/types/new_arrival_magazine_mail_setting'

export interface SearchBibliographyNewArrivalMagazineRequest {
  title: string
  searchType: NewArrivalMagazineSearchType
}

export function SearchBibliographyNewArrivalMagazineRequestToJSON(
  value: SearchBibliographyNewArrivalMagazineRequest
): any {
  return {
    title: value.title !== '' ? value.title : undefined,
    search_type: value.searchType ?? undefined
  }
}
